module.exports = "/fonts/fa-regular-400.svg?20af3d0e89d84cfca261212bfea3cb28";